import emoticons from './emoticons.json';

const EMOTICONS = new Map(Object.entries(emoticons));
// Each alphanumeric run is consumed whole so a long run cannot rescan quadratically.
// No lookbehind: Safari before 16.4 rejects it, and a bundle that fails to parse breaks the page.
const EMOTICON_PATTERN = /[a-zA-Z\d]+(?::\/\/\S+)?|:([a-z]+):/g;
const LETTER_OR_DIGIT_BEFORE = /[\p{L}\p{N}]$/u;
const LETTER_OR_DIGIT_AFTER = /^[\p{L}\p{N}]/u;

/** Finds the emoticon codes of a complete message that render as emoji, outside URL tokens and words. */
export function emoticonMatches(text) {
    const matches = [];
    text.replace(EMOTICON_PATTERN, (match, code, offset) => {
        const end = offset + match.length;
        // Two code units hold one astral letter, so the boundary checks read a surrogate pair whole.
        if (code !== undefined && EMOTICONS.has(code)
            && !LETTER_OR_DIGIT_BEFORE.test(text.slice(Math.max(0, offset - 2), offset))
            && !LETTER_OR_DIGIT_AFTER.test(text.slice(end, end + 2))) {
            matches.push({ start: offset, end, emoji: EMOTICONS.get(code) });
        }
        return match;
    });
    return matches;
}

/** Converts display text without changes to URL tokens or the source message. */
export function emoticonText(text) {
    return emoticonTextRange(text, 0, text.length);
}

/** Keeps URL and word boundaries from the full message for a correction segment. */
export function emoticonTextRange(text, start, end, matches = emoticonMatches(text)) {
    let rendered = '';
    let cursor = start;
    for (const match of matches) {
        if (match.start >= start && match.end <= end) {
            rendered += text.slice(cursor, match.start) + match.emoji;
            cursor = match.end;
        }
    }
    return rendered + text.slice(cursor, end);
}
